// doctor-onboarding-wizard.component.ts
import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormGroup } from '@angular/forms';
import { UserOnboardingComponent } from './user-onboarding-component/user-onboarding-component';
import { DoctorOnboardingComponent } from './doctor-onboarding-component/doctor-onboarding-component';
import { DoctorVerificationComponent } from './doctor-verification-component/doctor-verification-component';
import { UserOnboarding } from '../../core/models/user-onboarding.model';
import { DoctorOnboarding } from '../../core/models/doctor-onboarding.model';
import { RegistrationService } from '../../core/services/registration.service';

@Component({
  selector: 'onboarding',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, UserOnboardingComponent],
  templateUrl: './onboarding-component.html',
  styleUrls: ['./onboarding-component.scss'],
})
export class Onboarding {
  step = 1;

  @ViewChild(UserOnboardingComponent) step1!: UserOnboardingComponent;
  @ViewChild(DoctorOnboardingComponent) step2!: DoctorOnboardingComponent;
  @ViewChild(DoctorVerificationComponent) step3!: DoctorVerificationComponent;

  constructor(private registrationService: RegistrationService) {}

  nextStep() {
    if (this.currentStepValid()) this.step++;
    else this.currentForm()?.markAllAsTouched();
  }

  prevStep() {
    this.step--;
  }

  currentForm(): FormGroup | null {
    if (this.step === 1) return this.step1?.form ?? null;
    if (this.step === 2) return this.step2?.form ?? null;
    if (this.step === 3) return this.step3?.form ?? null;
    return null;
  }

  currentStepValid(): boolean {
    const form = this.currentForm();
    return form ? form.valid : false;
  }

  submitUserOnboarding(user: UserOnboarding) {
    this.registrationService.registerUser(user).subscribe((res) => {
      // this.nextStep();
    });
  }

  // submitDoctor(doctor: DoctorOnboarding) {
  //   this.registrationService.registerDoctor(doctor).subscribe((res) => {
  //     this.nextStep();
  //   });
  // }

  verifyDocuments(data: any) {}
}
